import { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import styles from "./breakingNews.module.scss";
//import Link from "next/link";

const BreakingNewsSlider = ({ breakingNewsData = null }) => {
  const [current, setCurrent] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const newsItems = breakingNewsData?.content;
  let interval;

  useEffect(() => {
    if (isPlaying) {
      interval = setInterval(goNext, 3000); // Change news item every 3 seconds
    }
    return () => clearInterval(interval);
  }, [isPlaying, current]);

  const goNext = () => {
    setCurrent((current + 1) % newsItems?.length);
  };

  const goPrevious = () => {
    setCurrent((current - 1 + newsItems?.length) % newsItems?.length);
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  if (!breakingNewsData || !breakingNewsData?.content) {
    return <></>;
  }

  return (
    <div className="hidden md:flex items-center justify-center mx-auto bg-gray-100 overflow-hidden min-h-[2.5rem] max-h-10">
      <div
        className={`${styles.breakingNews} flex items-center bg-primary text-white px-5 py-2 min-w-[210px]`}
      >
        <SVG
          src="/assets/icons/svg/bolt-icon.svg"
          className="mr-2 text-white w-6"
        />
        <span className="font-bold pe-10 whitespace-pre">Breaking News</span>
      </div>
      <div className="flex-grow p-2 overflow-hidden">
        <div className="h-6" style={{ display: "flex", alignItems: "center" }}>
          <a href={breakingNewsData?.canonical_url ?? "#"}>
            <p className="text-sm line-clamp-1">
              {newsItems[current ?? 0]?.title}
            </p>
          </a>
        </div>
      </div>
      <button onClick={goPrevious} className="p-2">
        &lt;
      </button>
      <button onClick={togglePlayPause} className="p-2">
        {isPlaying ? (
          <img
            src="/assets/icons/pause-button.png"
            loading="lazy"
            height={12}
            width={12}
            alt="Pause"
          />
        ) : (
          <img
            src="/assets/icons/play-button.png"
            loading="lazy"
            alt="play"
            height={12}
            width={12}
          />
        )}
      </button>
      <button onClick={goNext} className="p-2">
        &gt;
      </button>
    </div>
  );
};

export default BreakingNewsSlider;
